<app-modal-container [title]="header" [buttons]="modalButtons" [bigSize]="false" (dismissButtonClicked)="close(false)"
  (applyButtonClicked)="close(true)" [innerModal]="true">

  <div class="table-fms overflow-unset">
    <table>
      <thead style="position: unset;">
        <tr>
          <th class="first-level-left-sticky size-xl" colspan="2">Period</th>
          <th class="first-level-left-sticky size-m">Total</th>
          <th class="first-level-left-sticky size-m">Management fees</th>
          <th class="first-level-left-sticky size-m">Org. expenses</th>
          <th class="first-level-left-sticky size-m">Other expenses</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>First</td>
          <td>
            <app-selector
              class="selector-max-height-10"
              [openOnClick]="true"
              [outerClass]="'control-shrinked-container'"
              [data]="periodListFirst"
              [selectedItem]="selectedPeriodFirst"
              [blockRepositioning]="true"
              (itemEmitter)="switchPerformanceForFirstDate($event)">
            </app-selector>
          </td>
          <td>
            <span *ngIf="firstFundPerformance.totalExpenses">
              {{firstFundPerformance.totalExpenses | switcherDashBraces : 1 : 0}}
            </span>
          </td>
          <td>
            <span *ngIf="firstFundPerformance.mgmFees">
              {{firstFundPerformance.mgmFees | switcherDashBraces : 1 : 0}}
            </span>
          </td>
          <td>
            <span *ngIf="firstFundPerformance.aggregatedOrgExpenses">
              {{firstFundPerformance.aggregatedOrgExpenses | switcherDashBraces : 1 : 0}}
            </span>
          </td>
          <td>
            <span *ngIf="firstFundPerformance.totalExpenses - firstFundPerformance.aggregatedOrgExpenses
                    - firstFundPerformance.mgmFees">
              {{firstFundPerformance.totalExpenses - firstFundPerformance.aggregatedOrgExpenses
              - firstFundPerformance.mgmFees | switcherDashBraces : 1 : 0}}
            </span>
          </td>
        </tr>
        <tr>
          <td>Second</td>
          <td>
            <app-selector
              class="selector-max-height-10"
              [data]="periodListSecond"
              [outerClass]="'control-shrinked-container'"
              [selectedItem]="selectedPeriodSecond"
              [blockRepositioning]="true"
              (itemEmitter)="switchPerformanceForSecondDate($event)">
            </app-selector>
          </td>
          <td>
            <span *ngIf="secondFundPerformance.totalExpenses">
              {{secondFundPerformance.totalExpenses | switcherDashBraces : 1 : 0}}
            </span>
          </td>
          <td>
            <span *ngIf="secondFundPerformance.mgmFees">
              {{secondFundPerformance.mgmFees | switcherDashBraces : 1 : 0}}
            </span>
          </td>
          <td>
            <span *ngIf="secondFundPerformance.aggregatedOrgExpenses">
              {{secondFundPerformance.aggregatedOrgExpenses | switcherDashBraces : 1 : 0}}
            </span>
          </td>
          <td>
            <span *ngIf="secondFundPerformance.totalExpenses - secondFundPerformance.aggregatedOrgExpenses
                        - secondFundPerformance.mgmFees">
              {{secondFundPerformance.totalExpenses - secondFundPerformance.aggregatedOrgExpenses
              - secondFundPerformance.mgmFees | switcherDashBraces : 1 : 0}}
            </span>
          </td>
        </tr>
        <tr class="grand-total">
          <td>Predicted</td>
          <td>
            <div class="pd-0p5">
              {{predictedPeriod}}
            </div>
          </td>
          <td>
            <span *ngIf="predictedExpenses">{{predictedExpenses | switcherDashBraces : 1 : 0}}</span>
          </td>
          <td>
            <span *ngIf="mgmFees">{{mgmFees | switcherDashBraces : 1 : 0}}</span>
          </td>
          <td>
            <span *ngIf="aggregatedOrgExpenses">{{aggregatedOrgExpenses | switcherDashBraces : 1 : 0}}</span>
          </td>
          <td>
            <span *ngIf="otherExpenses">{{otherExpenses | switcherDashBraces : 1 : 0}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</app-modal-container>
